import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEye16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M14.784 7.08 12.6 4.271a2 2 0 0 0-1.578-.772H4.978a2 2 0 0 0-1.579.772L1.216 7.08a1.5 1.5 0 0 0 0 1.842L3.4 11.728a2 2 0 0 0 1.58.772h6.043a2 2 0 0 0 1.579-.772l2.183-2.807a1.5 1.5 0 0 0 0-1.842M2.4 8l2.184-2.807A.5.5 0 0 1 4.978 5h6.044a.5.5 0 0 1 .394.193L13.6 8l-2.184 2.807a.5.5 0 0 1-.394.193H4.978a.5.5 0 0 1-.394-.193z",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconEye16);
export default ForwardRef;
